import { render, staticRenderFns } from "./NotificationEdit.vue?vue&type=template&id=ab05f872&scoped=true&"
import script from "./NotificationEdit.vue?vue&type=script&lang=js&"
export * from "./NotificationEdit.vue?vue&type=script&lang=js&"
import style0 from "./NotificationEdit.vue?vue&type=style&index=0&id=ab05f872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab05f872",
  null
  
)

export default component.exports